<!-- 领用列表 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row slot="" v-if="dataActionBox.actionType!=2">
                      <el-form-item v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1" :label="formOneValue.showField" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1,trigger: ['blur', 'change']}] : []">
                        <el-input v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" :disabled="
                                                formOneValue.isChange == 0 ||
                                                dataActionBox.actionType == 2
                                                || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)
                                                ">
                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search" :disabled="
                                                    formOneValue.isChange == 0 ||
                                                    dataActionBox.actionType == 2
                                                    || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)
                                                    ">
                          </el-button>
                        </el-input>
                        <df-date v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0 ||
                                                dataActionBox.actionType == 2
                                                || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]"></df-date>

                        <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                          </el-option>
                        </el-select>
                        <el-input v-else-if="formOneValue.entityField == 'otsRemark'" :disabled="
                                            formOneValue.isChange == 0 ||
                                            dataActionBox.actionType == 2
                                            || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)
                                            " @keyup.enter.native="nextFocus(formOneKey)" type="textarea" v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                        <el-input v-else :disabled="
                                            formOneValue.isChange == 0 ||
                                            dataActionBox.actionType == 2
                                            || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)
                                            " @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField+':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                        <span v-if="formOneValue.fieldType == 'date'">
                          {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else> {{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div>
                    <el-form :inline="true" size="mini">
                      <div v-if="dataActionBox.actionType != 2" style="margin-bottom: 0.5rem">
                        <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                          新增明细</el-button>
                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                        </el-button>
                      </div>
                      <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey">
                          <template slot-scope="scope">
                            <!-- 显示通用名称 -->
                            <el-input :ref="formOneValue.entityField" v-if="formOneValue.fieldType == 'search'
                                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,formOneValue.nosetField)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                              <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,formOneValue.nosetField)" slot="append" icon="el-icon-search"></el-button>
                            </el-input>

                            <input class="newInput" @keyup.enter="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'tranNum' 
                                                        && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculatePrice(5, scope.$index)" type="number" v-model="sendDataInfo.detailList[scope.$index].tranNum" />
                            <!-- 含税价格 -->
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'psprice' 
                                                        && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculatePrice(2,scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                            </el-input>
                            <!-- 含税金额 -->
                            <el-input v-else-if="formOneValue.entityField == 'psmoney' 
                                                    && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField" type="number" @input="calculatePrice(4,scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                            </el-input>
                            <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" :ref="formOneValue.entityField" v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                            </el-input>
                            <span v-else-if="formOneValue.fieldType == 'date'">
                              <span v-if="scope.row[formOneValue.entityField]">
                                {{$common.getLocalTime(scope.row[formOneValue.entityField])}}
                              </span>
                            </span>
                            <span v-else>
                              {{sendDataInfo.detailList[scope.$index][formOneValue.entityField]}}
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType==2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
            </el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
          <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
              <el-button type="success">{{
                            sendDataInfo[itemV.entityField]
                            }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
  name: "officeSuppliesDetails",
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        "sbiAddress": "",
        "sbiCode": "",
        "sbiName": "",
        "sbiNumber": "",
        "sbiTelnumber": "",
        "smId": '',
        smName: '',
        isDefault: 0,   //是否默认
        remark: '',
        detailList: [],
        totalMoney: 0,
        totalNumber: 0,
        totalCount: 0,
        isAccount: 1
      },
      selectedDetailsIndex: 0,
      showTabs: "",
      formDataList: [],
      userOneList: [],
      seId: "",
      seWidth: "",
      height: "",
      seTitle: "",
      seWidth: "",
      DialogVisible: false,
      seType: "",
      smId: "",
      parentSearchData: {
        smId: "",
      },
      tables: false,
      mxHeight: 0,
      tabForm: [],
      mxForm: [],
      footForm: [],
      detaislDataInfo: {
        "batchno": "",
        "bgmId": '',
        "bgsId": '',
        "expidate": '',
        "lotno": "",
        "money": '',
        "price": '',
        "prodate": '',
        "psmoney": '',
        "psprice": '',
        "sterBatchno": "",
        "tranNum": '',
        outRate: 0,
      },
      selectedRow: [],
      fField: ''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    // "sendDataInfo.detailList": {
    //     handler: function (newValue, oldValue) {
    //         this.sendDataInfo.totalMoney = 0;
    //         this.sendDataInfo.totalNumber = 0;
    //         this.sendDataInfo.totalCount = 0;
    //         console.log(newValue)
    //         newValue.forEach((item, keys) => {
    //             let a = item.tranNum;
    //             if (item.tranNum == "") {
    //                 item.tranNum = 0;
    //             } else if (a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
    //                 item.tranNum = a.substring(1, a.length);
    //             }
    //             let b = item.psprice;
    //             if (item.psprice == "") {
    //                 item.psprice = 0;
    //             } else if (b.length > 1 && b.substring(0, 1) == "0" && b.substring(1, 2) != ".") {
    //                 item.psprice = b.substring(1, b.length);
    //             }
    //             this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
    //                 3,
    //                 NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
    //             );
    //             this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
    //                 1,
    //                 NP.plus(this.sendDataInfo.totalNumber, item.tranNum)
    //             );
    //         });
    //         this.sendDataInfo.totalCount = newValue.length;
    //         console.log(this.sendDataInfo)
    //     },
    //     deep: true,
    // },
  },
  //方法集合
  methods: {

    // 计算价格
    calculatePrice(cate = 1, index) {
      var info = this.sendDataInfo.detailList[index];
      if (info.tranNum > info.num) {
        info.tranNum = info.num
        this.$message.warning("不能大于库存数！")
      }
      console.log(info.psprice)
      info.tranNum = Number(info.tranNum)
      console.log(info.tranNum);
      if (info.tranNum <= 0) {
        this.$message({
          message: "请先填写合理的调拨数量",
          type: "error",
        });
        this.$set(info, "tranNum", 0);
        this.$set(info, "money", 0);
        this.$set(info, "psmoney", 0);
        return false;
      }
      switch (cate) {
        case 1: // 通过单价计算全部
          // 计算含税价格 单价+单价*税率/100
          var thisPrice = this.$common.getDecimalInfo(
            2,
            NP.plus(
              info.price,
              NP.divide(NP.times(info.price, info.outRate), 100)
            )
          );
          this.sendDataInfo.detailList[index].psprice = thisPrice;

          // 计算金额 单价*数量
          this.sendDataInfo.detailList[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.price, info.tranNum)
            );

          // 计算含税金额 含税价格*数量
          this.sendDataInfo.detailList[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.tranNum)
            );
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
          break;
        case 2: // 通过含税价格计算全部
          // this.getGoodsSockPrice(index)	//检测最低价/特价申请

          // 计算单价 含税价格/(税率/100+1)
          var thisPrice = this.$common.getDecimalInfo(
            2,
            NP.divide(info.psprice, NP.plus(NP.divide(info.outRate, 100), 1))
          );
          this.sendDataInfo.detailList[index].price = thisPrice;

          // 计算金额 单价*数量
          this.sendDataInfo.detailList[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPrice, info.tranNum)
            );

          // 计算含税金额 含税价格*数量
          this.sendDataInfo.detailList[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.psprice, info.tranNum)
            );
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
          break;
        case 3: // 通过金额计算全部
          // 计算单价  金额 / 数量
          var thisPrice = this.$common.getDecimalInfo(
            2,
            NP.divide(info.money, info.tranNum)
          );
          this.sendDataInfo.detailList[index].price = thisPrice;

          // 计算含税价格 单价+单价*税率/100
          var thisPriceTwo = this.$common.getDecimalInfo(
            3,
            NP.plus(
              thisPrice,
              NP.divide(NP.times(thisPrice, info.outRate), 100)
            )
          );
          this.sendDataInfo.detailList[index].psprice = thisPriceTwo;

          // 计算含税金额 含税价格*数量
          this.sendDataInfo.detailList[index].psmoney =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.tranNum)
            );
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
          break;

        case 4: // 通过含税金额计算全部
          // 计算含税价格  含税金额 / 数量
          var thisPrice = this.$common.getDecimalInfo(
            3,
            NP.divide(info.psmoney, info.tranNum)
          );
          this.sendDataInfo.detailList[index].psprice = thisPrice;

          // 计算单价 含税价格/(税率/100+1)
          var thisPriceTwo = this.$common.getDecimalInfo(
            2,
            NP.divide(thisPrice, NP.plus(NP.divide(info.outRate, 100), 1))
          );
          this.sendDataInfo.detailList[index].price = thisPriceTwo;
          // 计算金额 单价*数量
          this.sendDataInfo.detailList[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(thisPriceTwo, info.tranNum)
            );
          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
          break;
        default:
          //通过数量计算
          // 计算金额 单价*数量

          this.sendDataInfo.detailList[index].money =
            this.$common.getDecimalInfo(
              3,
              NP.times(info.price, info.tranNum)
            );

          // 计算含税金额 含税价格*数量
          var moneyOne = this.$common.getDecimalInfo(
            3,
            NP.times(info.psprice, info.tranNum)
          );
          this.sendDataInfo.detailList[index].psmoney = moneyOne;
          // 计算整件数量
          this.sendDataInfo.detailList[index].wholeNum = Math.floor(info.tranNum / Number(info.packingSpec))

          //计算零散数量
          this.sendDataInfo.detailList[index].scatNum = info.tranNum - info.wholeNum * Number(info.packingSpec)

          //计算税额
          this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))

          // 计算件数 采数/包装单位
          if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
            this.sendDataInfo.detailList[index].pieceNum = 0;
          } else {
            this.sendDataInfo.detailList[index].pieceNum =
              this.$common.getDecimalInfo(
                1,
                NP.divide(info.tranNum, info.packingSpec)
              );
          }
          break;
      }

      // 单价
      var moneyOne = this.sendDataInfo.detailList[index].price;
      // 含税价
      var moneyTwo = this.sendDataInfo.detailList[index].psprice;
      // 金额
      var moneyThree = this.sendDataInfo.detailList[index].money;
      // 含税金额
      var moneyFour = this.sendDataInfo.detailList[index].psmoney;

      //页脚
      this.sendDataInfo.totalMoney = moneyFour;
      this.sendDataInfo.totalNumber = info.tranNum;
      this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length;
      this.sendDataInfo.detailList.splice(1, 0)

    },
    deleteDetails() {
      if (this.sendDataInfo.detailList.length < 1) {
        return this.$message({
          message: "暂无可删除明细",
          type: "warning",
        });
      }
      this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
      if (this.sendDataInfo.detailList.length > 1) {
        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
      } else {
        this.selectedDetailsIndex = 0;
      }
      this.tableNextFocus("bgmName", this.selectedDetailsIndex);
      let refsElTable = this.$refs.mxTableRef;
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(
        this.sendDataInfo.detailList[this.selectedDetailsIndex]
      );
    },

    // 表格切换焦点方法
    tableNextFocus(field, index) {
      console.log(field, index)
      if (field == "keydown") {
        if (this.sendDataInfo.detailList[index + 1] != undefined) {
          this.$refs["bgmName"][index + 1].focus();
          return;
        }
        this.addDetail("sendDataInfo");
        return;
      }
      this.$refs[field][index].focus();
    },
    // 保存已选择行
    handleSelectionChange(rows) {
      this.selectedRow = rows; // 保存已选择行
    },
    // 明细表格点击选中
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.mxTableRef; // 获取表格对象
      let findRow = {};
      this.selectedDetailsIndex = row.rowIndex;
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
    },
    // 表格方法
    rowClassName({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
    },
    //新增明细
    addDetail(sendDataInfo) {
      var flag = false
      if (this.sendDataInfo.detailList.length > 0) {
        this.sendDataInfo.detailList.forEach(item => {
          if (item.bgmId == "") {
            flag = true
            this.$nextTick(() => {
              this.selectedDetailsIndex = Number(
                this.sendDataInfo.detailList.length - 1
              );
              this.tableNextFocus("bgmName", this.selectedDetailsIndex);
              let refsElTable = this.$refs.mxTableRef;
              refsElTable.clearSelection();
              refsElTable.toggleRowSelection(
                this.sendDataInfo.detailList[this.selectedDetailsIndex]
              );
            });
          }
        })
      }
      if (flag) {
        return
      }
      this.sendDataInfo.detailList.push({})
      var index = this.sendDataInfo.detailList.length - 1
      for (const key in this.detaislDataInfo) {
        this.$set(this.sendDataInfo.detailList[index], key, this.detaislDataInfo[key])
      }
      this.$nextTick(() => {
        this.selectedDetailsIndex = Number(
          this.sendDataInfo.detailList.length - 1
        );
        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
        let refsElTable = this.$refs.mxTableRef;
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(
          this.sendDataInfo.detailList[this.selectedDetailsIndex]
        );
      });
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById('mainInfo')
      if (el) this.inputel = el.getElementsByTagName('input')
    },
    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
          this.inputel[index].focus()
          break
        }
      }
    },
    // 输入框切换焦点
    nextFocus(index) {
      if (index >= (this.inputel.length - 1)) return
      var aindex = index + 1
      if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
        this.nextFocus(aindex)
        return
      }
      this.inputel[aindex].focus()
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
          .printJurId)
      } else {
        return
      }
    },
    // 默认值
    initDefaultValue() {
      let arr = this.formDataList[0].jurconfigform
      arr.forEach(item => {
        if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
          this.sendDataInfo[item.entityField] = item.defaultValue
        }
      })
    },
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    //检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField, fField) {
      this.DialogVisible = true;
      this.seId = sId;
      this.seIndex = index;
      this.seType = type;
      this.sField = sField;
      this.fField = fField
      if (type == "bgmName") {
        this.parentSearchData.outcoId = this.sendDataInfo.outcoId;
        this.parentSearchData.bgmName =
          this.sendDataInfo.detailList[this.seIndex].bgmName;
        return;
      }
      this.parentSearchData[type] = this.sendDataInfo[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.sendDataInfo[item] = val[item]
      })
      this.$nextTick(() => {
        this.nextFocus(this.seIndex)
      })
    },
    // 表格赋值字段
    mxParamValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo.detailList[this.seIndex][item] = val[item];
      });
      this.sendDataInfo.detailList.splice(1, 0)
    },
    changeInputModel(val) {
      console.log(val, this.seType)
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        if (this.seType == "bgmName") {
          for (let key in val) {
            this.sendDataInfo.detailList[this.seIndex][key] =
              val[key];
            if (this.sendDataInfo.detailList[this.seIndex][key] == null) this.sendDataInfo.detailList[this.seIndex][key] = ''
          }
          this.tableNextFocus(this.fField, this.seIndex);
          console.log(this.sendDataInfo.detailList[this.seIndex])
          return
        }
        this.paramValue(val)
      }
    },

    initActionBox(sendDataInfo) {
      this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dataActionBox.actionType = 0;
          this.$emit('drawerCancel')
          this.tables = false;
          this.init();
          this.$refs[sendDataInfo].resetFields();
        })
        .catch(() => {
        });
    },
    init() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = "";
      }
      this.sendDataInfo.detailList = []
      this.sendDataInfo.isDefault = 0;
      this.sendDataInfo.isAccount = 1;
    },


    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = this.actionData.formData
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.filterMainField()
      this.init();
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = "新增信息";
        this.dataActionBox.openMode = "ltr";
        // this.initDefaultValue()
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = "编辑信息";
        this.dataActionBox.openMode = "rtl";
        for (let key in oldData) {
          this.sendDataInfo[key] = oldData[key];
        }
      } else {
        this.tables = true
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }

      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
          this.initFocus()
        }, 16.7)
      })
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sub();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async sub() {
      if (this.sendDataInfo.detailList.length < 1) {
        this.$message({
          message: "请添加明细",
          type: "error",
        });
        return;
      } else {
        this.sendDataInfo.detailList.forEach((item, index) => {
          if (item.bgmId == "") {
            this.sendDataInfo.detailList.splice(index, 1);
          }
        });
      }
      if (
        this.sendDataInfo.detailList.some(
          (val) =>
            (val.bgmName != "" && val.tranNum == "") ||
            val.tranNum <= 0 ||
            val.psmoney <= 0
        )
      ) {
        this.$message({
          type: "error",
          message: "明细商品采购数量含税金额不能为0或者空",
        });
        return;
      }
      this.sendDataInfo.totalCount=this.sendDataInfo.detailList.length
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
      if (this.dataActionBox.actionType == 0) {
        // 新增预付款
        var responseData = await this.$http.addOwnertransfer(sendData);
      } else {
        // 暂时没有编辑接口
        var responseData = await this.$http.updateOwnertransfer(sendData);
      }
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit('drawerCancel', true)
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
          this.mxForm.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
            .jurconfigform[index])
        }
      })
      var arr = [{ entityField: "detailList" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, "isDefault", 0)
      this.$set(this.sendDataInfo, "isAccount", 0)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput()
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.mb {
  margin-bottom: 0;
}

.newInput {
  height: 28px;
  line-height: 28px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>